//Bet slip variables
export const OPEN_BETS = 'OPEN_BETS';
export const UNREAD_BETS = 'UNREAD_BETS';
export const DEFAULT_STAKES = 'DEFAULT_STAKES';

//Settings
export const ODDS_TYPE = 'ODDS_TYPE';
export const VID_VISIBLE = 'VID_VISIBLE';
export const SYS_LANGUAGE = 'SYS_LANGUAGE';

//BonusBet
export const HIDE_GIFT_FOR_YOU = 'HIDE_GIFT_FOR_YOU';
export const OPTED_CAMPAING_IDS = 'OPTED_CAMPAING_IDS';
export const HIDE_GIFT_TILL = 'HIDE_GIFT_TILL';



// WEBPACK FOOTER //
// ./src/constants/localStorage.js